import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from '../../../config/withDirection';

const StyleWrapper = styled.li`
    position: relative;
    list-style-type: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 14px;
    padding: 26px 33px 26px 39px;
    background-color: rgba(249, 249, 249, 1);

    > * { width: 100%; }

    .loading-overlay {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, .3);
    }

    .loading-word {
        flex-grow: 1;
        align-self: center;
        text-align: center;
        font-weight: 700;
        text-transform: uppercase;
    }

    .row-wrapper { display: flex; flex-wrap: wrap; }

    a {
        flex-grow: 1;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    a:hover { text-decoration: none; }

    .app-header {
        display: inline-flex;
        margin: 0;
        margin-bottom: 14px;
        width: 100%;
        max-width: 370px;
        padding-right: 14px;
    }
    .app-header dt { margin-right: 11px; min-width: 85px; width: 85px; }
    .app-header dt img { border-radius: 16px; width: 100%; }

    .app-header dd {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }
    .app-header dd .app-name,
    .app-header dd .app-desc {
        display: block;
        line-height: 1.1;
        font-family: 'Montserrat';
        color: rgba(64, 55, 57, 1);
    }
    .app-header dd .app-name {
        font-size: 22px;
        font-weight: 300;
        letter-spacing: 0.09em;
        text-transform: uppercase;
    }
    .app-header dd .app-desc {
        font-size: 14px;
        text-align: left;
        letter-spacing: 0.07em;
    }

    .breakdowns {
        position: relative;
        bottom: -26px;
        margin-top: 7px;
        border-top: 1px solid rgba(0, 0, 0, .1);
        width: 100%;
    }
    .breakdowns button {
        width: 100%;
        padding: 14px 7px;
        background-color: transparent;

        &:hover { outline-width: 0; border-width: 0; }
        &:not(:only-child) { border-top: 1px solid rgba(0, 0, 0, .1); }
    }

    .breakdowns li {
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 14px 0 14px 56px;
    }
    .breakdowns li .region-description img { margin-right: 7px; width: 42px; }

    @media screen and (max-width: 991px) {
        @media screen and (min-width: 768px) {
            a { justify-content: center; }
            a > :only-child { max-width: 100%; }
        }
    }

    @media screen and (max-width: 767px) {
        a { flex-wrap: wrap; width: calc(100% - 71px); }

        .breakdowns li { padding-left: 0; }
        .breakdowns li .region-description { min-width: 80px; padding-right: 7px; }
    }

    @media screen and (max-width: 480px) {
        justify-content: start;
        padding: 26px 17px;

        a { width: 100%; }
        .app-header dt { min-width: 50px; width: 50px; }
        .app-header dt img { border-radius: 10px; }

        .app-name { margin-bottom: 7px; font-size: 18px; }
        .app-desc { font-size: 16px; }

        .breakdowns li { flex-wrap: wrap; padding-bottom: 28px; }
        .breakdowns li:not(:last-child) { border-bottom: 1px solid rgba(0, 0, 0, .1); }
        .breakdowns li .region-description { flex-grow: 1; align-self: flex-end; order: 1; text-align: center; }
        .breakdowns li .region-description ~ .breakdown:last-child { order: 2; }
    }
`;

export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/containers/CampaignList/CampaignItem/Wrapper.js